/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.getElementById('Search-Drawer');
    this.headerSearch = document.getElementById('header-search');
    this.headerSearchButton = document.getElementById('header-search-button');
    this.form = this.container.querySelector('form.searchform');
    this.button = document.querySelectorAll('.thb-quick-search');
    this.input = this.container.querySelector('input[type="search"]');
    this.defaultTab = this.container.querySelector('.side-panel-content--initial');
    this.predictiveSearchResults = this.container.querySelector('.side-panel-content--has-tabs');

    this.setupEventListeners();

    // Restore the last searched keyword (same persistence the vehicle dropdowns
    // get via pp-vehicle-gid) so leaving the page and coming back keeps both
    // halves of the search, not just the vehicle.
    const savedKeyword = sessionStorage.getItem('pp-keyword');
    if (savedKeyword && this.input && !this.input.value) {
      this.input.value = savedKeyword;
      if (this.headerSearch) {
        this.headerSearch.value = savedKeyword;
      }
    }
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    // Opening the drawer focuses the input; when it comes prefilled (restored
    // pp-keyword) the input event never fires, so search on focus too.
    this.input.addEventListener('focus', this.onFocus.bind(this));

    this.button.forEach((item, i) => {
      item.addEventListener('click', (event) => {
        var _this = this;
        event.preventDefault();
        document.getElementsByTagName("body")[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
        if (this.container.classList.contains('active')) {
          setTimeout(function() {
            _this.input.focus({
              preventScroll: true
            });
          }, 100);
          dispatchCustomEvent('search:open');
        }

        return false;
      });
    });

      this.headerSearch.addEventListener('click', (event) => {
        var _this = this;
        event.preventDefault();
        document.getElementsByTagName("body")[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
        if (this.container.classList.contains('active')) {
          setTimeout(function() {
            _this.input.focus({
              preventScroll: true
            });
          }, 100);
          dispatchCustomEvent('search:open');
        }

        return false;
      });
    
      this.headerSearchButton.addEventListener('click', (event) => {
        var _this = this;
        event.preventDefault();
        document.getElementsByTagName("body")[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
        if (this.container.classList.contains('active')) {
          setTimeout(function() {
            _this.input.focus({
              preventScroll: true
            });
          }, 100);
          dispatchCustomEvent('search:open');
        }

        return false;
      });
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.predictiveSearchResults.classList.remove('active');
      return;
    }
    this.predictiveSearchResults.classList.add('active');
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
      return;
    }
    // Remember the keyword so it survives navigation, like the vehicle does.
    sessionStorage.setItem('pp-keyword', this.getQuery());
    // Carry the selected vehicle into the search so results intersect keyword + vehicle.
    const vehicleGid = sessionStorage.getItem('pp-vehicle-gid');
    if (vehicleGid) {
      let hidden = this.form.querySelector('input[name="vehicle_id"]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'vehicle_id';
        this.form.appendChild(hidden);
      }
      hidden.value = vehicleGid;
    }
    // Keep the selected category too: searching a new keyword while a collection
    // is applied must NOT drop it. The collection can live EITHER in a native
    // collection page's path (/collections/<handle>) OR in the app-search query
    // (?collection=<handle>) — check both so the filter survives from anywhere.
    const pathColl = (window.location.pathname.match(/\/collections\/([^\/?#]+)/) || [])[1];
    let currentColl = pathColl && pathColl !== 'all' ? pathColl : new URLSearchParams(window.location.search).get('collection');
    let collHidden = this.form.querySelector('input[name="collection"]');
    if (currentColl) {
      if (!collHidden) {
        collHidden = document.createElement('input');
        collHidden.type = 'hidden';
        collHidden.name = 'collection';
        this.form.appendChild(collHidden);
      }
      collHidden.value = currentColl;
    } else if (collHidden) {
      collHidden.remove();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.predictiveSearchResults.classList.add('active');
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    this.predictiveSearchResults.classList.add('loading');

    // Always query our App Proxy — the same engine that powers the full
    // results page — so the drawer's suggestions and "View All Results" can
    // never disagree (same fields, same availability order, same vehicle
    // intersection). The native predictive API matched by SKU/tags/vendor
    // and produced results the full page then couldn't reproduce.
    const ppVehicleGid = sessionStorage.getItem('pp-vehicle-gid');
    const vehicleParam = ppVehicleGid ? `vehicle_id=${encodeURIComponent(ppVehicleGid)}&` : '';

    fetch(`/apps/pp-search/search?${vehicleParam}q=${encodeURIComponent(searchTerm)}&view=drawer`)
      .then((response) => {
        this.predictiveSearchResults.classList.remove('loading');
        if (!response.ok) { throw new Error(response.status); }
        return response.text();
      })
      .then((html) => {
        // The App Proxy wraps our fragment in the full theme layout; extract just the results grid.
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const results = parsed.querySelector('.pp-search-results');
        const label = ppVehicleGid ? sessionStorage.getItem('pp-vehicle-label') : null;
        const note = label
          ? `<p class="pp-search-vehicle-note" style="margin:0 0 10px;padding:8px 12px;background:#fdece7;color:#c0341d;font-weight:600;border-radius:4px;">Showing parts that fit your vehicle — ${label}</p>`
          : '';
        const body = results
          ? results.outerHTML
          : `<p style="text-align: center; margin-top: 20px; width: 80%; align-self: center;">No results found for "${searchTerm}". Check the spelling or use a different word or phrase.</p>`;
        this.predictiveSearchResults.innerHTML = note + body;
      })
      .catch(() => {
        this.predictiveSearchResults.classList.remove('loading');
      });
  }

  // renderSearchResults(resultsMarkup) {
  //   this.predictiveSearchResults.innerHTML = resultsMarkup;

  //   let _this = this,
  //     submitButton = this.container.querySelector('#search-results-submit');


  //   submitButton.addEventListener('click', () => {
  //     _this.form.submit();
  //   });
  // }

  renderSearchResults(resultsMarkup) {
  const searchTerm = this.getQuery();
  const containsProducts = resultsMarkup.includes('product-card-small'); 

  if (!containsProducts) {
    // Display a message if no products are found
    this.predictiveSearchResults.innerHTML = `
    <p style="text-align: center; margin-top: 20px; width: 80%; align-self: center;">
      No results found for "${searchTerm}". Check the spelling or use a different word or phrase.
    </p>`;
  } else {
    // Render the results as usual
    this.predictiveSearchResults.innerHTML = resultsMarkup;
  }

  let _this = this,
    submitButton = this.container.querySelector('#search-results-submit');

  submitButton?.addEventListener('click', () => {
    _this.form.submit();
  });
  }
  
  close() {
    this.container.classList.remove('active');
  }
}
window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    new PredictiveSearch();
  }
});